/**
 * 根据当前语言返回对应的字体
 * @param {string} language - 当前语言 ('zh', 'zh_TW', 'en')
 * @returns {string} 字体名称
 */
export const getLanguageFont = (language) => {
  switch (language) {
    // case 'zh':
    //   return 'Ctrip Font';
    case 'en':
      // return 'Trip Number TF';
      return 'Trip Geom TF';
    case 'zh_TW':
      return 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
    default:
      return 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
  }
};

/**
 * 获取带有回退的字体样式
 * @param {string} language - 当前语言
 * @returns {string} 完整的 font-family 字符串
 */
export const getLanguageFontWithFallback = (language) => {
  const primaryFont = getLanguageFont(language);
  const fallbackFonts = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
  
  // 如果主字体已经是系统字体，直接返回
  if (primaryFont.includes('system-ui')) {
    return primaryFont;
  }
  
  // 否则添加回退字体
  return `${primaryFont}, ${fallbackFonts}`;
};

